import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export default function Flow() {
  return (
    <section className="inside-quote-section">
      <Container>
        <Row>
          <Col lg="10" className="mx-auto">
            <div className="flow-content text-center text-white">
              <div className="d-flex justify-content-center section-title mb-4 align-items-center">
                <h2 className="d-flex justify-content-center section-title mb-4 align-items-center">
                  <span className="">
                    <StaticImage
                      className="img-fluid"
                      src="../../images/flow-logo.png"
                      alt="Logo"
                    />
                  </span>
                </h2>
              </div>
              <h2 className="youthtouch">
                FLUO is where Family makes a comeback!
              </h2>
              {/* <h5 className="youthtouch">~Nathan Hildreth, Founder of FLUO</h5> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
